import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("UnitMAS/Create", objinsert);
  }
  getdata() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("UnitMAS/List");
  }
  Edit(EditId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("UnitMAS/Get?id=" + EditId + "");
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete("UnitMAS/Delete?id=" + DelID);
  }
  //Active
  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "UnitMAS/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("UnitMAS/Update", objupdate);
  }
}
export default new Commonservices();
